"use client";

import Link from "next/link";
import Image from "next/image";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function NotFoundPage() {
  return (
    <div className="flex flex-col min-h-screen bg-white text-gray-800">
      {/* Main content */}
      <main
        className="flex-1 flex flex-col items-center justify-center text-center px-6 py-16"
        style={{
          backgroundImage: "url('/images/bg-pattern-1.png')",
          backgroundRepeat: "repeat",
        }}
      >
        <div className="max-w-md animate-fadeInUp">
          <Image
            src="/images/logo.png"
            alt="CareFirst Logo"
            width={250}
            height={100}
            className="mx-auto mb-6 opacity-90"
          />

          <h1 className="text-5xl font-bold text-[#1f3d1f] mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">
            Page Not Found
          </h2>
          <p className="text-gray-600 mb-8 leading-relaxed">
            The page you’re looking for might have been moved, deleted, or may
            never have existed.  
            Let’s get you back on track.
          </p>

          <Link
            href="/"
            className="inline-block px-6 py-3 bg-[#9fce8a] text-[#1f3d1f] font-semibold rounded-lg shadow hover:bg-[#85b674] transition-colors duration-300"
          >
            Return Home
          </Link>
        </div>
      </main>
    </div>
  );
}
